<template>
    <v-select
            :label="(label)? label : 'Empresa'"
            :items="empresas"
            :value="value"
            :multiple="multiple"
            :error-messages="errores.collect('empresa')"
            item-avatar="avatar"
            small-chips
            hide-selected
            v-validate="validate"
            data-vv-name="empresa"
            required
            @input="actualizaValor($event)"
            @change="change($event)"
            clearable
    >
        <template slot="selection" slot-scope="data">
            <v-chip small
                    :close="multiple"
                    @input="data.parent.selectItem(data.item)"
                    :selected="data.selected"
                    class="chip--select-multi"
                    :key="JSON.stringify(data.item)"
            >
                <v-avatar>
                    <img :src="data.item.avatar">
                </v-avatar>
                {{ data.item.text }}
            </v-chip>
        </template>
        <template slot="item" slot-scope="data">
            <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
                <v-list-tile-avatar>
                    <img v-bind:src="data.item.avatar"/>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                </v-list-tile-content>
            </template>
        </template>
    </v-select>
</template>
<script>
    export default {
        inject: ['$validator'],
        name: 'empresa-select',
        props: ['multiple', 'label', 'filtro', 'value', 'chips', 'validate'],
        data() {
            return {
                datos: {
                    1: {value: 1, text: 'Friolatina', avatar: './img/iso-1.svg'},
                    2: {value: 2, text: 'Bervill', avatar: './img/iso-2.svg'},
                    3: {value: 3, text: 'Acerolatina', avatar: './img/iso-3.svg'},
                },
                empresa: ''
            }
        },
        computed: {
            empresas() {
                let r = []
                if (this.filtro) { // el array de filtro son las empresas que se van a mostrar.. no todas
                    for (let i = 0; i < this.filtro.length; i++) {
                        if (this.datos[this.filtro[i]]) {
                            r.push(this.datos[this.filtro[i]])
                        }
                    }
                } else {
                    for (let i = 1; i <= 3; i++) {
                        r.push(this.datos[i])
                    }
                }
                return r
            }
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor);
                this.$emit('actualiza', valor);
            },
            change(e) {
                this.$emit('change', e);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/EmpresaSelect.vue